import { Card, Empty, Select, Space, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { t } from 'i18next'
import SimpleLayout from '../../../core/components/layout/SimpleLayout'
import ApiService from '../../../core/service/ApiService'
import UnitFormTemplateBuilder from './UnitFormTemplateBuilder'

/** Birim seçimi + builder. Onam formu şablonları birim bazlı olduğu için önce birim seçilir. */
export default function UnitFormTemplatePage() {
    const history = useHistory()
    const { unitId } = useParams()

    const [units, setUnits] = useState([])
    const selected = unitId ? Number(unitId) : null

    useEffect(() => {
        ApiService.Unit.GetUnitList().then((res) => {
            if (res.success) setUnits(res.data || [])
        })
    }, [])

    return (
        <SimpleLayout fullWidth={true}>
            <Card
                title={
                    <Space>
                        <Typography.Text strong>{t('Onam Formu Şablonları')}</Typography.Text>
                        <Select
                            size="small"
                            showSearch
                            optionFilterProp="label"
                            style={{ minWidth: 260 }}
                            placeholder={t('Birim seçin')}
                            value={selected || undefined}
                            onChange={(id) => history.push(`/app/system/unit-form-templates/${id}`)}
                            options={units.map((u) => ({ value: u.id, label: u.visibleName || u.name }))}
                        />
                    </Space>
                }
            >
                {selected ? (
                    <UnitFormTemplateBuilder unitId={selected} />
                ) : (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('Devam etmek için birim seçin')} />
                )}
            </Card>
        </SimpleLayout>
    )
}
